import { Checkbox } from '@mui/material';
import React from 'react';
import Employee from '../../types/api/Employee';
import { days } from '../../types/api/Days';



interface EmployeeAvailabilitiesProps {
    compact: boolean,
    readOnly: boolean,
    baseEmployee: Employee,
    onUpdate?: (emp: Employee)=>void
}
export function EmployeeAvailabilities(EmployeeAvailabilitiesProps: EmployeeAvailabilitiesProps) {
    const tableClassName = EmployeeAvailabilitiesProps.compact ? 'w-full' : '';

    if( !EmployeeAvailabilitiesProps.readOnly && !EmployeeAvailabilitiesProps.onUpdate){
        console.error("Les disponibilités ne sont pas en readOnly, mais aucune fonction de modification n'a était donnée.")
    }
    return (
        <table className={tableClassName}>
            <tbody>
                <tr>
                    <th></th>
                    <th className='p-1'>{days.Monday}</th>
                    <th className='p-1'>{days.Tuesday}</th>
                    <th className='p-1'>{days.Wednesday}</th>
                    <th className='p-1'>{days.Thursday}</th>
                    <th className='p-1'>{days.Friday}</th>
                    <th className='p-1'>{days.Saturday}</th>
                    <th className='p-1'>{days.Sunday}</th>
                </tr>
                <tr className='text-center'>
                    <td>MIDI</td>
                    <td>
                    <Checkbox 
                        color='success'
                        disabled={EmployeeAvailabilitiesProps.readOnly}
                        checked={EmployeeAvailabilitiesProps.baseEmployee.MondayNoon}
                        onChange={(event: React.ChangeEvent<HTMLInputElement>)=>{
                            if(EmployeeAvailabilitiesProps.onUpdate)EmployeeAvailabilitiesProps.onUpdate({...EmployeeAvailabilitiesProps.baseEmployee, MondayNoon: event.target.checked})
                        }}
                    />
                    </td>
                    <td>
                    <Checkbox
                        color='success'
                        disabled={EmployeeAvailabilitiesProps.readOnly}
                        checked={EmployeeAvailabilitiesProps.baseEmployee.TuesdayNoon}
                        onChange={(event: React.ChangeEvent<HTMLInputElement>)=>{
                            if(EmployeeAvailabilitiesProps.onUpdate)EmployeeAvailabilitiesProps.onUpdate({...EmployeeAvailabilitiesProps.baseEmployee, TuesdayNoon: event.target.checked})
                        }}
                    />
                    </td>
                    <td>
                    <Checkbox
                        color='success'
                        disabled={EmployeeAvailabilitiesProps.readOnly}
                        checked={EmployeeAvailabilitiesProps.baseEmployee.WednesdayNoon}
                        onChange={(event: React.ChangeEvent<HTMLInputElement>)=>{
                            if(EmployeeAvailabilitiesProps.onUpdate)EmployeeAvailabilitiesProps.onUpdate({...EmployeeAvailabilitiesProps.baseEmployee, WednesdayNoon: event.target.checked})
                        }}
                    />
                    </td>
                    <td>
                    <Checkbox
                        color='success'
                        disabled={EmployeeAvailabilitiesProps.readOnly}
                        checked={EmployeeAvailabilitiesProps.baseEmployee.ThursdayNoon}
                        onChange={(event: React.ChangeEvent<HTMLInputElement>)=>{
                            if(EmployeeAvailabilitiesProps.onUpdate)EmployeeAvailabilitiesProps.onUpdate({...EmployeeAvailabilitiesProps.baseEmployee, ThursdayNoon: event.target.checked})
                        }}
                    />
                    </td>
                    <td>
                    <Checkbox
                        color='success'
                        disabled={EmployeeAvailabilitiesProps.readOnly}
                        checked={EmployeeAvailabilitiesProps.baseEmployee.FridayNoon}
                        onChange={(event: React.ChangeEvent<HTMLInputElement>)=>{
                            if(EmployeeAvailabilitiesProps.onUpdate)EmployeeAvailabilitiesProps.onUpdate({...EmployeeAvailabilitiesProps.baseEmployee, FridayNoon: event.target.checked})
                        }}
                    />
                    </td>
                    <td>
                    <Checkbox
                        color='success'
                        disabled={EmployeeAvailabilitiesProps.readOnly}
                        checked={EmployeeAvailabilitiesProps.baseEmployee.SaturdayNoon}
                        onChange={(event: React.ChangeEvent<HTMLInputElement>)=>{
                            if(EmployeeAvailabilitiesProps.onUpdate)EmployeeAvailabilitiesProps.onUpdate({...EmployeeAvailabilitiesProps.baseEmployee, SaturdayNoon: event.target.checked})
                        }}
                    />
                    </td>
                    <td>
                    <Checkbox
                        color='success'
                        disabled={EmployeeAvailabilitiesProps.readOnly}
                        checked={EmployeeAvailabilitiesProps.baseEmployee.SundayNoon}
                        onChange={(event: React.ChangeEvent<HTMLInputElement>)=>{
                            if(EmployeeAvailabilitiesProps.onUpdate)EmployeeAvailabilitiesProps.onUpdate({...EmployeeAvailabilitiesProps.baseEmployee, SundayNoon: event.target.checked})
                        }}
                    />
                    </td>
                </tr>
                <tr className='text-center'>
                    <td>SOIR</td>
                    <td>
                    <Checkbox
                        color='success'
                        disabled={EmployeeAvailabilitiesProps.readOnly}
                        checked={EmployeeAvailabilitiesProps.baseEmployee.MondayEvening}
                        onChange={(event: React.ChangeEvent<HTMLInputElement>)=>{
                            if(EmployeeAvailabilitiesProps.onUpdate)EmployeeAvailabilitiesProps.onUpdate({...EmployeeAvailabilitiesProps.baseEmployee, MondayEvening: event.target.checked})
                        }}
                    />
                    </td>
                    <td>
                    <Checkbox
                        color='success'
                        disabled={EmployeeAvailabilitiesProps.readOnly}
                        checked={EmployeeAvailabilitiesProps.baseEmployee.TuesdayEvening}
                        onChange={(event: React.ChangeEvent<HTMLInputElement>)=>{
                            if(EmployeeAvailabilitiesProps.onUpdate)EmployeeAvailabilitiesProps.onUpdate({...EmployeeAvailabilitiesProps.baseEmployee, TuesdayEvening: event.target.checked})
                        }}
                    />
                    </td>
                    <td>
                    <Checkbox
                        color='success'
                        disabled={EmployeeAvailabilitiesProps.readOnly}
                        checked={EmployeeAvailabilitiesProps.baseEmployee.WednesdayEvening}
                        onChange={(event: React.ChangeEvent<HTMLInputElement>)=>{
                            if(EmployeeAvailabilitiesProps.onUpdate)EmployeeAvailabilitiesProps.onUpdate({...EmployeeAvailabilitiesProps.baseEmployee, WednesdayEvening: event.target.checked})
                        }}
                    />
                    </td>
                    <td>
                    <Checkbox
                        color='success'
                        disabled={EmployeeAvailabilitiesProps.readOnly}
                        checked={EmployeeAvailabilitiesProps.baseEmployee.ThursdayEvening}
                        onChange={(event: React.ChangeEvent<HTMLInputElement>)=>{
                            if(EmployeeAvailabilitiesProps.onUpdate)EmployeeAvailabilitiesProps.onUpdate({...EmployeeAvailabilitiesProps.baseEmployee, ThursdayEvening: event.target.checked})
                        }}
                    />
                    </td>
                    <td>
                    <Checkbox
                        color='success'
                        disabled={EmployeeAvailabilitiesProps.readOnly}
                        checked={EmployeeAvailabilitiesProps.baseEmployee.FridayEvening}
                        onChange={(event: React.ChangeEvent<HTMLInputElement>)=>{
                            if(EmployeeAvailabilitiesProps.onUpdate)EmployeeAvailabilitiesProps.onUpdate({...EmployeeAvailabilitiesProps.baseEmployee, FridayEvening: event.target.checked})
                        }}
                    />
                    </td>
                    <td>
                    <Checkbox
                        color='success'
                        disabled={EmployeeAvailabilitiesProps.readOnly}
                        checked={EmployeeAvailabilitiesProps.baseEmployee.SaturdayEvening}
                        onChange={(event: React.ChangeEvent<HTMLInputElement>)=>{
                            if(EmployeeAvailabilitiesProps.onUpdate)EmployeeAvailabilitiesProps.onUpdate({...EmployeeAvailabilitiesProps.baseEmployee, SaturdayEvening: event.target.checked})
                        }}
                    />
                    </td>
                    <td>
                    <Checkbox
                        color='success'
                        disabled={EmployeeAvailabilitiesProps.readOnly}
                        checked={EmployeeAvailabilitiesProps.baseEmployee.SundayEvening}
                        onChange={(event: React.ChangeEvent<HTMLInputElement>)=>{
                            if(EmployeeAvailabilitiesProps.onUpdate)EmployeeAvailabilitiesProps.onUpdate({...EmployeeAvailabilitiesProps.baseEmployee, SundayEvening: event.target.checked})
                        }}
                    />
                    </td>
                </tr>
            </tbody>
        </table>
    );
}

export default EmployeeAvailabilities;